/**
 * description: 描述信息
 * author: bql
 * 2023/6/15 8:48
 */
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class ContractClassesApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'contract-classes'
    }

}
 